<template>
    <section class="main" v-loading.body="loading">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <div class="people hidden-sm hidden-xs"
                         :style="{ background: 'url(' + featuredImage +') center no-repeat', backgroundSize: 'cover'}"
                    ></div>
                </div>
                <div class="col-md-6">
                    <div class="main_content">
                        <img :src="logo" alt="community management logo" class="logo">
                        <h1 class="main_title">{{ title }}</h1>
                        <p class="title_bottom_text">{{ subTitle }}</p>
                        <div class="login_area">
                            <h3>
                                Welcome To {{ title }}. Please Login To Access.
                            </h3>
                            <button class="btn btn-lg btn-success login_btn" @click="makeLogin('sensa')">
                                <span v-html="buttonText"></span>
                            </button>
                        </div>
                        <div class="bottom_text">
                            <p v-html="footerText"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/babel">
    export default {
        name: 'login',
        props: ['api'],
        data () {
            return {
                msg: 'Hello There',
                context: 'oauth2 context',
                type: 'sensa',
                loginConfig: window.loginConfig,
                sensaProvider: {
                    clientId: config.APP_ID,
                    url: config.AUTH_URL,
                    redirect: config.REDIRET,
                    scope: '',
                    responseType: 'token',
                    state: {}
                },
                featuredImage: window.loginConfig.featuredImage,
                logo: window.loginConfig.logo,
                title: window.loginConfig.communityName,
                subTitle: window.loginConfig.subtitle,
                buttonText: window.loginConfig.loginButtonText,
                footerText: window.footerConfig.footer_text,
                loading: true
            };
        },
        mounted() {
            Event.$emit('set_title', 'Login');
            Event.$emit('endLoading');
        },

        methods: {
            makeLogin(type) {
                $auth.performOauth2Authorize(this.sensaProvider);
            },
            setImages() {
                let communityId = localStorage.getItem('communityId');

                if (communityId) {
                    axios.get(this.api.findCommunity(communityId))
                        .then(response => {
                            if (response.data.cover_photo) {
                                this.featuredImage = response.data.cover_photo;
                            }

                            if (response.data.logo) {
                                this.logo = response.data.logo;
                            }

                            this.title = response.data.title;

                            this.subTitle = response.data.description;

                            this.loading = false;
                        })
                        .catch(error => {})
                } else {
                    this.loading = false;
                }
            }
        },
        created() {
            this.setImages();
            Event.$emit('set_title', window.config.APP_NAME);
            Event.$emit('endLoading');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    .main {
        min-height: 100vh;
        color: #fff;
        text-align: center;
        position: relative;
    }

    .main .main_content .login_area h3 {
        font-size: 22px;
        line-height: 25px;
        font-weight: 300;
        margin-bottom: 30px;
        margin-top: 0;
    }

    .main .main_content {
        background: #2486c6;
        padding: 30px 0 10px;
    }

    .main .main_content, .main .people {
        min-height: 100vh;
        margin-left: -15px;
        margin-right: -15px;
    }

    .main .main_content .logo {
        max-width: 400px;
        height: 80px;
        display: block;
        margin: auto;
    }

    .main .main_content .main_title {
        font-size: 4vh;
    }

    .main .main_content .title_bottom_text {
        margin: 4vh 5vh;
    }

    .main .main_content .login_area {
        background: #fff;
        color: #000;
        padding: 25px 20px;
        margin: 0 2vh;
        border-radius: 4px;
    }

    .main .main_content .bottom_text {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
    }

    @media (min-width: 480px) {
        .main .main_content .title_bottom_text {
            margin: 8vh 15vh 5vh;
        }

        .main .main_content .login_area {
            margin: 8vh 15vh 5vh;
        }
    }

    @media (max-width: 479px) {
        .main .main_content .btn-lg {
            padding: 10px 15px;
            min-width: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?2357feb1